module.exports = __webpack_public_path__ + "img/icon_works.1db3a768.svg";